module.exports = __webpack_public_path__ + "img/robinhood.9ee63c26.png";